import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=1b6cdda4&scoped=true&"
import script from "./loader.js?vue&type=script&lang=js&"
export * from "./loader.js?vue&type=script&lang=js&"
import style0 from "./loader.scss?vue&type=style&index=0&id=1b6cdda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6cdda4",
  null
  
)

export default component.exports